import { render, staticRenderFns } from "./clientProfileForms.vue?vue&type=template&id=56f5a7fb&scoped=true"
import script from "./clientProfileForms.vue?vue&type=script&lang=js"
export * from "./clientProfileForms.vue?vue&type=script&lang=js"
import style0 from "./clientProfileForms.vue?vue&type=style&index=0&id=56f5a7fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f5a7fb",
  null
  
)

export default component.exports